import { useEffect, useState } from 'react';

import { useQueryParams } from '../../utils/queryParams';
import { AIRLINES, AIRLINES_QUERY_PARAMS_MAP } from '../../constants';
import { apiClient } from '../apiClient';

const defaultFlightDisplayList = { Jal: true, Ana: true };

export const useFlightList = () => {
  const query = useQueryParams();
  const [fetched, setFetched] = useState(false);
  const [defaultCarrier, setDefaultCarrier] = useState(AIRLINES.jal);
  const [flightDisplayList, setFlightDisplayList] = useState(defaultFlightDisplayList);

  useEffect(() => {
    let isMounted = true;

    const init = async () => {
      const handleQueryParams = (query) => {
        const flightDisplayListFromQueryParams = getFlightListFromQueryParams(query);
        setFlightDisplayList(flightDisplayListFromQueryParams);
      };

      try {
        const { data } = await apiClient.getFlightList();

        if (!isMounted) {
          return;
        }

        if (data && data.flight_list) {
          setDefaultCarrier(AIRLINES_QUERY_PARAMS_MAP[data.flight_list.default.toUpperCase()]);
          const flightDisplayListFromQueryParams = getFlightListFromQueryParams(query, data.flight_list.display);
          setFlightDisplayList(flightDisplayListFromQueryParams);
        } else {
          handleQueryParams(query);
        }

      }
      catch (e) {
        isMounted && handleQueryParams(query);
      }
      finally {
        isMounted && setFetched(true);
      }
    };

    init();

    return () => {
      isMounted = false;
    };
  }, []);

  return { fetched, defaultCarrier, flightDisplayList };
};


const getFlightListFromQueryParams = (query, initialFlightDisplayList = defaultFlightDisplayList) => {
  const { SelTab: selTab, Carrier: carrier } = query;

  const showOnlySelectedTab = selTab === '1';
  if (!showOnlySelectedTab) {
    return initialFlightDisplayList;
  }

  const selectedCarrier = AIRLINES_QUERY_PARAMS_MAP[carrier];

  if (!(selectedCarrier && initialFlightDisplayList[selectedCarrier])) {
    return initialFlightDisplayList;
  }

  const flightDisplayList = { [selectedCarrier]: true };

  return flightDisplayList;
};

export const validateFlightListJson = (json) => {
  const { default: defaultCarrier, display } = json;

  if (!defaultCarrier) {
    return false;
  }

  return !!display[defaultCarrier];
};